export default "__VITE_ASSET__DxKsjIDk__"